"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ColorGideHelp;
var React = _interopRequireWildcard(require("react"));
var _internal = require("@aws-amplify/ui-react/internal");
var _uiReact = require("@aws-amplify/ui-react");
var _Clock = _interopRequireDefault(require("./Clock"));
var _Payment = _interopRequireDefault(require("./Payment"));
var _Ticket = _interopRequireDefault(require("./Ticket"));
var _IconStore = _interopRequireDefault(require("./IconStore"));
var _excluded = ["overrides"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function ColorGideHelp(props) {
  var overrides = props.overrides,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "0",
    direction: "column",
    width: "360px",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "ColorGideHelp"), rest), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "24px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "12px 12px 12px 12px",
    backgroundColor: "rgba(255,255,255,1)"
  }, (0, _internal.getOverrideProps)(overrides, "ColorGideHelp34712391")), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "left",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "unset",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Esta es una gu\xEDa que te ayudar\xE1 a llenar correctamente tu libreta de pagos"
  }, (0, _internal.getOverrideProps)(overrides, "Instructions"))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 20983")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "20px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 24px 0px",
    backgroundColor: "rgba(255,255,255,1)"
  }, (0, _internal.getOverrideProps)(overrides, " ColorGuide34733355")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "7px",
    direction: "row",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 20884")), /*#__PURE__*/React.createElement(_Clock.default, _extends({
    width: "24px",
    height: "24px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "default"
  }, (0, _internal.getOverrideProps)(overrides, "Clock34733357"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "20px",
    fontWeight: "700",
    color: "rgba(27,29,54,1)",
    lineHeight: "25px",
    textAlign: "left",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    width: "unset",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Asistencia"
  }, (0, _internal.getOverrideProps)(overrides, "Asist")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "30px",
    direction: "row",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2098034733359")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2097734733360")), /*#__PURE__*/React.createElement(_Clock.default, _extends({
    width: "54px",
    height: "54px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "success"
  }, (0, _internal.getOverrideProps)(overrides, "Clock34733361"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "center",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "92px",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "A tiempo"
  }, (0, _internal.getOverrideProps)(overrides, "ATiempo")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2097834733363")), /*#__PURE__*/React.createElement(_Clock.default, _extends({
    width: "54px",
    height: "54px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "warning"
  }, (0, _internal.getOverrideProps)(overrides, "Clock34733364"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "center",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "92px",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Lleg\xF3 tarde"
  }, (0, _internal.getOverrideProps)(overrides, "LlegoTarde")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2097934733366")), /*#__PURE__*/React.createElement(_Clock.default, _extends({
    width: "54px",
    height: "54px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "error"
  }, (0, _internal.getOverrideProps)(overrides, "Clock34733367"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "center",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "92px",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "No asisti\xF3"
  }, (0, _internal.getOverrideProps)(overrides, "NoAsistio")))))), /*#__PURE__*/React.createElement(_uiReact.Divider, _extends({
    width: "unset",
    height: "1px",
    shrink: "0",
    alignSelf: "stretch",
    size: "small",
    orientation: "horizontal"
  }, (0, _internal.getOverrideProps)(overrides, "Divider34931564"))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "20px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 24px 0px",
    backgroundColor: "rgba(255,255,255,1)"
  }, (0, _internal.getOverrideProps)(overrides, " ColorGuide34733386")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "7px",
    direction: "row",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 20903")), /*#__PURE__*/React.createElement(_Payment.default, _extends({
    width: "24px",
    height: "24px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "default"
  }, (0, _internal.getOverrideProps)(overrides, "Payment34733388"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "20px",
    fontWeight: "700",
    color: "rgba(27,29,54,1)",
    lineHeight: "25px",
    textAlign: "left",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    width: "unset",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    grow: "1",
    shrink: "1",
    basis: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Pago semanal"
  }, (0, _internal.getOverrideProps)(overrides, "PagoSemanal")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "40px",
    direction: "row",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2098034733390")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "148px",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2097734733391")), /*#__PURE__*/React.createElement(_Payment.default, _extends({
    width: "54px",
    height: "54px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "success"
  }, (0, _internal.getOverrideProps)(overrides, "Payment34733392"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "center",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "92px",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Completo"
  }, (0, _internal.getOverrideProps)(overrides, "Completo")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "148px",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2097834733394")), /*#__PURE__*/React.createElement(_Payment.default, _extends({
    width: "54px",
    height: "54px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "warning"
  }, (0, _internal.getOverrideProps)(overrides, "Payment34733395"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "center",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "92px",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Incompleto"
  }, (0, _internal.getOverrideProps)(overrides, "Incompleto")))))), /*#__PURE__*/React.createElement(_uiReact.Divider, _extends({
    width: "unset",
    height: "1px",
    shrink: "0",
    alignSelf: "stretch",
    size: "small",
    orientation: "horizontal"
  }, (0, _internal.getOverrideProps)(overrides, "Divider34931566"))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "20px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 24px 0px",
    backgroundColor: "rgba(255,255,255,1)"
  }, (0, _internal.getOverrideProps)(overrides, " ColorGuide34733422")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "7px",
    direction: "row",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2090434733423")), /*#__PURE__*/React.createElement(_Ticket.default, _extends({
    width: "24px",
    height: "24px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "default"
  }, (0, _internal.getOverrideProps)(overrides, "Ticket34733424"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "20px",
    fontWeight: "700",
    color: "rgba(27,29,54,1)",
    lineHeight: "25px",
    textAlign: "left",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    width: "unset",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    grow: "1",
    shrink: "1",
    basis: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Pago solidario"
  }, (0, _internal.getOverrideProps)(overrides, "PagoSolidario34733425")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "30px",
    direction: "row",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2098034733426")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2097734733427")), /*#__PURE__*/React.createElement(_Ticket.default, _extends({
    width: "54px",
    height: "54px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "success"
  }, (0, _internal.getOverrideProps)(overrides, "Ticket34733428"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "center",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "92px",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Si"
  }, (0, _internal.getOverrideProps)(overrides, "Si34733429")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2097834733430")), /*#__PURE__*/React.createElement(_Ticket.default, _extends({
    width: "54px",
    height: "54px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "error"
  }, (0, _internal.getOverrideProps)(overrides, "Ticket34733431"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "center",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "92px",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "No"
  }, (0, _internal.getOverrideProps)(overrides, "No34733432")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 2097934733433")), /*#__PURE__*/React.createElement(_Ticket.default, _extends({
    width: "54px",
    height: "54px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    overflow: "hidden",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "disabled"
  }, (0, _internal.getOverrideProps)(overrides, "Ticket34733434"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "center",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "92px",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "No fue necesario"
  }, (0, _internal.getOverrideProps)(overrides, "NoNecesario")))))), /*#__PURE__*/React.createElement(_uiReact.Divider, _extends({
    width: "unset",
    height: "1px",
    shrink: "0",
    alignSelf: "stretch",
    size: "small",
    orientation: "horizontal"
  }, (0, _internal.getOverrideProps)(overrides, "Divider4150808"))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "20px",
    direction: "column",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 24px 0px",
    backgroundColor: "rgba(255,255,255,1)"
  }, (0, _internal.getOverrideProps)(overrides, " ColorGuide4150809")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "7px",
    direction: "row",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 209044150810")), /*#__PURE__*/React.createElement(_IconStore.default, _extends({
    width: "24px",
    height: "24px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "default"
  }, (0, _internal.getOverrideProps)(overrides, "iconStore4150811"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "20px",
    fontWeight: "700",
    color: "rgba(27,29,54,1)",
    lineHeight: "25px",
    textAlign: "left",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    width: "unset",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    grow: "1",
    shrink: "1",
    basis: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Negocio"
  }, (0, _internal.getOverrideProps)(overrides, "PagoSolidario4150812")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "40px",
    direction: "row",
    width: "unset",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    alignSelf: "stretch",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 209804150813")), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "150px",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 209774150814")), /*#__PURE__*/React.createElement(_IconStore.default, _extends({
    width: "54px",
    height: "54px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "success"
  }, (0, _internal.getOverrideProps)(overrides, "iconStore4150815"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "center",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "92px",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "Si"
  }, (0, _internal.getOverrideProps)(overrides, "Si4150816")))), /*#__PURE__*/React.createElement(_uiReact.Flex, _extends({
    gap: "12px",
    direction: "column",
    width: "150px",
    height: "unset",
    justifyContent: "flex-start",
    alignItems: "center",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px"
  }, (0, _internal.getOverrideProps)(overrides, "Frame 209784150817")), /*#__PURE__*/React.createElement(_IconStore.default, _extends({
    width: "54px",
    height: "54px",
    display: "block",
    gap: "unset",
    alignItems: "unset",
    justifyContent: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    variation: "error"
  }, (0, _internal.getOverrideProps)(overrides, "iconStore4150818"))), /*#__PURE__*/React.createElement(_uiReact.Text, _extends({
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "rgba(27,29,54,1)",
    lineHeight: "24px",
    textAlign: "center",
    display: "block",
    direction: "column",
    justifyContent: "unset",
    letterSpacing: "0.01px",
    width: "92px",
    height: "unset",
    gap: "unset",
    alignItems: "unset",
    shrink: "0",
    position: "relative",
    padding: "0px 0px 0px 0px",
    whiteSpace: "pre-wrap",
    children: "No"
  }, (0, _internal.getOverrideProps)(overrides, "No4150819")))))))));
}